import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import InfoIcon from '@mui/icons-material/Info';
import { Typography } from '@mui/material';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

// Removendo anotações de tipo
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const Details = () => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Button variant="outlined" size="small" onClick={handleClickOpen}>
        <InfoIcon />
      </Button>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        sx={{
          '& .MuiDialog-paper': {
            width: '600px',
            maxWidth: '100%',
            borderRadius: '10px',
            padding: '20px',
          },
        }}
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle sx={{ fontWeight: '500', fontSize: '20px' }}>
          IAGO
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Typography variant="body1" paragraph>
            "Olá! Eu sou o IAGO, seu atendente virtual com inteligência artificial! Fui criado para ajudar você de forma rápida, eficiente e personalizada. Pode contar comigo para tirar dúvidas, fornecer informações importantes e tornar sua experiência aqui ainda mais prática e agradável. Estou sempre pronto para ajudar você a encontrar exatamente o que precisa. Vamos juntos? 🚀"
            </Typography>

            {/* <Typography variant="body1" paragraph>
              O Dreams Coffee 2.0 tem um sabor delicioso e cremoso, semelhante ao Nescafé, porém ainda mais saboroso.
              Ele contém cafeína natural proveniente do café verde, que proporciona energia de forma suave e sustentada
              ao longo do dia. O Dreams Coffee 2.0 é aprovado pela ANVISA e não possui efeitos colaterais conhecidos.
              Gestantes, lactantes, crianças e hipertensos devem evitar o consumo.
            </Typography> */}

            {/* <Typography variant="h6" sx={{ fontWeight: '500', marginTop: '10px' }}>
              Informações Importantes:
            </Typography> */}
            {/* <List>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon color="success" />
                </ListItemIcon>
                <ListItemText primary="Produto termogênico" />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon color="success" />
                </ListItemIcon>
                <ListItemText primary="Aumenta o foco e a energia" />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <ErrorIcon color="error" />
                </ListItemIcon>
                <ListItemText primary="Não recomendado para gestantes, lactantes, crianças e hipertensos" />
              </ListItem>
            </List> */}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
